import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthState } from '@app/store/auth/auth.state';
import { Store } from '@ngxs/store';

@Injectable({
  providedIn: 'root',
})
export class RoleGuardService implements CanActivate {
  constructor(private _router: Router, private _store: Store) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const auth = this._store.selectSnapshot(AuthState);

    if (
      !auth ||
      (route.data.roles && !route.data.roles.some((role: string) => auth.roles.includes(role)))
    ) {
      this._router.navigate(['login']);
      return false;
    }

    return true;
  }
}
